module.exports = __webpack_public_path__ + "img/pin-4000.5dff5e03.png";